import { gql } from '@apollo/client';

const getSEOLinksQuery = () => {
  const query = gql`
  query SEOLinks($path: String) {
      seoLinks(path: $path)
  }
  `;

  return query;
};

export default getSEOLinksQuery;
